import Global from "@/mixins/global";
import Vue from "vue";

Vue.mixin(Global);
